import type { TabRegistryEntry } from "@/types/tabs";
import { LayoutDashboard, Briefcase, Clock, FileText, MessageSquare } from "lucide-react";

import ContractLaborDashboard from "@/pages/contract-labor/ContractLaborDashboard";
import ContractLaborWorkOrders from "@/pages/contract-labor/ContractLaborWorkOrders";
import ContractLaborLogHours from "@/pages/contract-labor/ContractLaborLogHours";
import ContractLaborDocuments from "@/pages/contract-labor/ContractLaborDocuments";
import Comms from "@/pages/controller/Comms";

export const contractLaborTabRegistry: TabRegistryEntry[] = [
  { routePattern: "/portal/contract-labor", component: ContractLaborDashboard, label: "Home", icon: LayoutDashboard, closable: false, singleton: true },
  { routePattern: "/portal/contract-labor/work-orders", component: ContractLaborWorkOrders, label: "Work Orders", icon: Briefcase, closable: true, singleton: true },
  { routePattern: "/portal/contract-labor/log-hours", component: ContractLaborLogHours, label: "Log Hours", icon: Clock, closable: true, singleton: true },
  { routePattern: "/portal/contract-labor/documents", component: ContractLaborDocuments, label: "Documents", icon: FileText, closable: true, singleton: true },
  { routePattern: "/portal/contract-labor/comms", component: Comms, label: "Comms", icon: MessageSquare, closable: true, singleton: true },
];
